import * as urls from "utils/contants/urls";

import { Body, DashBoardBody, Row } from "./DashBoardPlugStyle";
import React, { Fragment, PureComponent } from "react";
import { Route, Switch } from "react-router";

import DashBoardPlugMain from "../DashBoardPlugMain";

import { ConnectedRouter } from "connected-react-router";
import Header from "components/Layout/header/Header";
import ListDocumentsCandidates from "../Documents/ListDocumentsCandidates";
import ListDocuments from "../Documents/ListDocuments";
import ListDoubtsCandidates from "../Doubts/ListDoubtsCandidates";

import ListContractsCandidates from "../Contracts/ListContractsCandidates";
import DetailContractCandidate from "../Contracts/DetailContractCandidate";

import ManagerCandidatesContract from "../Contracts/ManagerCandidatesContract";

import DocumentsCandidatesViewer from "../Documents/ImageViewer";

import Menu from "../Menu/Menu";
import MessageHandler from "components/MessageHandler";
import { connect } from "react-redux";

class DashBoardPlug extends PureComponent {
  render() {
    const { history } = this.props;
    return (
      <Fragment>
        <Header location={history} />
        <DashBoardBody>
          <Row>
            <Menu />
            <Body>
              <ConnectedRouter history={history}>
                <Switch>
                  <Route exact path={urls.PLUG_AEC} component={DashBoardPlugMain} />
                  <Route exact path={urls.DOUBTS_LIST} component={ListDoubtsCandidates} /> 
                  <Route exact path={urls.DOCUMENTS_CANDIDATES} component={ListDocumentsCandidates} />   
                  <Route exact path={`${urls.DOCUMENTS_LIST}/:id`}  component={ListDocuments} />  
                  <Route exact path={urls.CONTRACTS_LIST} component={ListContractsCandidates} />   
                  <Route exact path={`${urls.CONTRACT_CANDIDATE}/:id`}  component={DetailContractCandidate} />       
                  <Route exact path={`${urls.CONTRACT_MANAGER}`}  component={ManagerCandidatesContract} />       
                  <Route exact path={`${urls.DOCUMENTS_CANDIDATES_VIEWER}`}  component={DocumentsCandidatesViewer} />       

                      
                </Switch>
              </ConnectedRouter>
            </Body>
          </Row>
        </DashBoardBody>
        <MessageHandler />
      </Fragment>
    );
  }
}
const mapStateToProps = state => ({
  location: state.history
});
export default connect(mapStateToProps)(DashBoardPlug);
